/**
 * The workspace's panels (Test, Verification, Publish, Runs, Settings), loaded
 * lazily from ./panels/. `import.meta.glob` lists only the files that exist, so
 * a panel not written yet renders a placeholder instead of breaking the build.
 */
import { lazy } from 'react';

const files = import.meta.glob('./panels/*Panel.js');

function NotYet() {
  return <p className="pw__line pw__muted">Not here yet.</p>;
}

const slot = (name) => {
  const load = files[`./panels/${name}.js`];
  return lazy(() => (load ? load() : Promise.resolve({ default: NotYet })));
};

export const PANELS = {
  test: slot('TestPanel'),
  verification: slot('VerifyPanel'),
  publish: slot('PublishPanel'),
  runs: slot('RunsPanel'),
  settings: slot('SettingsPanel'),
};
